module.exports = __webpack_public_path__ + "static/media/livecontent.76c69031.webp";